<script lang="ts">
  export let name = '';
</script>

<p class="text-base">
  Discover the curated artworks collection of <strong>{name}</strong>, where each piece is presented in digital format
  with its verified authenticity and rarity, and secured on the blockchain.
</p>
